export enum startupStateTypes {
  none = 0,
  starting = 1,
  completed = 2,
  error = 3,
}
